import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import '../styles/Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated, user, logout } = useAuth();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setIsMenuOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const onResize = () => {
      if (window.innerWidth > 834) setIsMenuOpen(false);
    };
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  const handleLogout = () => {
    const redirectPath = logout(location.pathname + location.search);
    navigate(redirectPath);
  };

  return (
    <header className={`apple-nav ${scrolled ? 'is-scrolled' : ''} ${isMenuOpen ? 'is-open' : ''}`}>
      <div className="apple-nav-inner">
        <Link to="/" className="apple-nav-brand" aria-label="미라이쥬쿠 홈">
          <span className="apple-nav-mark">未来塾</span>
          <span className="apple-nav-name">Miraijuku</span>
        </Link>

        <button
          type="button"
          className="apple-nav-toggle"
          aria-expanded={isMenuOpen}
          aria-label="메뉴"
          onClick={() => setIsMenuOpen((v) => !v)}
        >
          <span />
          <span />
        </button>

        <nav className={`apple-nav-menu ${isMenuOpen ? 'is-open' : ''}`}>
          <Link to="/guides">가이드</Link>
          <Link to="/finder">루트 찾기</Link>
          <Link to="/checklist">요강 체크</Link>
          <Link to="/compare">비교</Link>
          <Link to="/calendar">일정</Link>
          <Link to="/alerts">알림</Link>
          <Link to="/resources">공식 자료</Link>
          <Link to="/universities">대학 입시</Link>
          <Link to="/consulting">신청</Link>
          <Link to="/about">소개</Link>
          {isAuthenticated && user?.role === 'admin' && <Link to="/admin">관리자</Link>}
          {isAuthenticated ? (
            <>
              <Link to="/dashboard">계정</Link>
              <button type="button" className="apple-nav-textbtn" onClick={handleLogout}>
                로그아웃
              </button>
            </>
          ) : (
            <Link to="/login" state={{ from: location.pathname }}>로그인</Link>
          )}
        </nav>
      </div>
    </header>
  );
};

export default Header;
